
import React, { useEffect, useState } from 'react'
import { Modal, Button } from 'antd';
import { useModel } from "../../models";
import { scmPrint } from "../../utils/constants";

export default ({ }) => {
    const [{preview}, {setPreview}] = useModel("global")

    //打印
    const print = () => {
        scmPrint(preview.__html)
    };
    // 取消
    const cancel = () => {
        setPreview({visible: false, __html: null})
    }

    return (    
        <Modal
            title="打印预览"
            width={1000}
            visible={preview.visible}
            onCancel={cancel}
            footer={[
                <Button onClick={cancel} key="back"> 取消</Button>,
                <Button type="primary" onClick={print} key="submit">确认打印</Button>,
            ]}
        >
            <div dangerouslySetInnerHTML={preview}></div>
        </Modal>
    )
};
